import * as Yup from 'yup';
import { System } from '../../models/system';

export function useValidationSchema() {
  return Yup.object<System>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
